import React from "react";
import { useState } from "react";
import axios from "axios"

function CustomerSearchF2Popup(props) {

    let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"

    const {selectCustomerOrganization, userDepartment,setF2CustomerSearch} = props

    const [organizationList, setOrganizationList] = useState(null)

    const fetchOrganizationList = async (value) => {
        // setTimeout(async() => {
        if (!value || value.length < 1) {
            return;
        } else {
            try {
                const response = await axios.get(
                    `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Customer/${company_code_from_local_storage}/Cust/${value}/${userDepartment}`
                );
                // console.log("organizationList is fetched success", response.data);
                setOrganizationList(response.data);
            } catch (error) {
                console.log("Error fetching organization details:", error);
            }
        }
    };

    const handleChangeInput = (e) => {

        fetchOrganizationList(e.target.value)

    }

    return (

        <div className="ItemSearchPopup-root-container p-10">

            <div className="bg-white p-4 max-h-full">
                <div style={{display:"flex", justifyContent:"space-between"}}>

                    <input onChange={(e) => handleChangeInput(e)} placeholder="search customer" />

                    <button className="bg-blue-500 border-0 text-white  px-6 border"   onClick={()=>setF2CustomerSearch(false)}>X</button>

                </div>

                <div  style={{maxHeight:"calc(70vh - 100px)", overflowY:"scroll" ,marginTop:"10px"}}>
                    {organizationList?.map((organization, index) => (
                            <div
                                onClick={() => {
                                    selectCustomerOrganization(organization);
                                    setF2CustomerSearch(false)
                                }}
                                key={index}
                                className="px-1 py-0.5 border bg-white hover:bg-gray-200"
                            >
                                <p className="font-normal">{organization.Custname}</p>
                                {/* <p className="text-xs text-gray-500">
                                {product.Description}
                              </p>
                              <p className="text-xs text-gray-500">
                                {product.Imagepath}
                              </p> */}
                            </div>
                        ))}
                </div>

            </div>
        </div>
    )
}

export default CustomerSearchF2Popup;